var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-empty-table-comp"},[_c('include-svg',{attrs:{"name":_vm.icon}}),(_vm.title.length)?_c('h5',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }